import React, { useState, useEffect, useRef } from "react";
import Card from "../../../components/Global/Card";
import { AiOutlineShop, AiOutlineEdit } from "react-icons/ai";
import DataTable from "../../../components/Global/DataTable";
import Modal from "../../../components/Global/Modal";
import { CustomService } from "../../../services/api/custom/CustomService";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import GoBack from "../../../components/Utils/GoBack";
import { toast } from "react-toastify";

const VendedoresPage = ({ user }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [toRemove, setToRemove] = useState(null);
  const navigate = useNavigate();
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    fetchData();
  }, []);

  useEffect(() => {
    if (!user.admin) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const vendedores = await CustomService.getRequest("/interno/vendedores");
      setData(vendedores || []);
    } catch (error) {
      console.error("Erro ao buscar vendedores:", error);
      toast.error("Não foi possível carregar os vendedores.");
    } finally {
      setLoading(false);
    }
  };

  const removeVendedor = async () => {
    try {
      await CustomService.deleteRequest(`/interno/vendedor/${toRemove.id}`);
      toast.success("Vendedor excluído com sucesso!");
      fetchData();
    } catch (error) {
      console.error("Erro ao excluir vendedor:", error);
      toast.error("Erro ao excluir vendedor.");
    } finally {
      setShowRemoveModal(false);
      setToRemove(null);
    }
  };

  const columns = [
    { title: "CPF", dataIndex: "cpf", key: "cpf" },
    { title: "Nome", dataIndex: "nome", key: "nome" },
    { title: "Telefone", dataIndex: "telefone", key: "telefone" },
    { title: "Email", dataIndex: "email", key: "email" },
  ];

  const actions = {
    onEdit: (record) => navigate(`/cadastro/vendedor/${record.id}`),
    onDelete: (record) => {
      setToRemove(record);
      setShowRemoveModal(true);
    },
  };

  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/dashboard" />

      {showRemoveModal && (
        <Modal
          buttonName="Excluir"
          title="Confirmar exclusão"
          handleModal={setShowRemoveModal}
          eventConfirmation={removeVendedor}
          size="md:w-1/3"
        >
          <div className="flex flex-col justify-center items-center">
            <span>
              Deseja excluir o vendedor <b>{toRemove?.nome}</b>?
            </span>
            <span className="text-[14px]">Esta ação é irreversível.</span>
          </div>
        </Modal>
      )}

      <Card
        buttonActionPath="/cadastro/vendedor"
        title="Vendedores"
        icon={<AiOutlineShop className="w-[25px] h-[25px]" />}
      >
        <div className="w-full">
          <DataTable
            size="100%"
            data={data}
            columns={columns}
            paginationOptions={{ pageSize: 5000 }}
            actions={actions}
            actionIcons={{ edit: <AiOutlineEdit /> }}
            loading={loading}
          />
        </div>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(VendedoresPage);
